import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

import ErrorBoundaryPage from 'pages/ErrorBoundaryPage';

const PrivateRoute = ({ component: Component, isAuth, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuth) {
        return <Redirect to={`/login?redirect=${encodeURIComponent(window.location.pathname)}`} />;
      }

      return (
        <ErrorBoundaryPage>
          <Component {...props} {...rest} />
        </ErrorBoundaryPage>
      );
    }}
  />
);

PrivateRoute.defaultProps = {
  isAuth: false,
  component: undefined,
};

PrivateRoute.propTypes = {
  isAuth: PropTypes.bool,
  component: PropTypes.func,
};

export default PrivateRoute;
